import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/app';
import './styles/index.css';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('Unable to start Prisco: #root element is missing in index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
